import {
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

export const confirmPickupSchema = vObject({
  pickupNumber: vString(),
  proNumber: vOptional(vString()),
  token: vString(),
})

export type ConfirmPickupRequest = vOutput<typeof confirmPickupSchema>
